import { DiwaAPI } from './client'

/** The import receipt: what linked, what was created, what asks in the ◈ inbox. */
export interface ImportResult {
  note_id: string
  title?: string
  deduped: boolean
  linked: string[]
  created: string[]
  suggested: number
}

/** The edit receipt: an import receipt plus what the edit UNLINKED. */
export interface UpdateResult {
  note_id: string
  title?: string
  unchanged: boolean
  linked: string[]
  unlinked: string[]
  created: string[]
  suggested: number
}

export interface TroveDoc {
  id: string
  title: string | null
  filename: string | null
  source: string
  created_at: string
}

export class TroveAPI {
  private api: DiwaAPI

  constructor(baseUrl: string) {
    this.api = new DiwaAPI(baseUrl)
  }

  importNote(
    content: string,
    opts?: { filename?: string; source?: 'upload' | 'obsidian' | 'capture' },
  ): Promise<ImportResult> {
    return this.api.post<ImportResult>('/trove/import', {
      content,
      filename: opts?.filename ?? null,
      source: opts?.source ?? 'upload',
    })
  }

  list(): Promise<TroveDoc[]> {
    return this.api.get<TroveDoc[]>('/trove')
  }

  detail(id: string): Promise<{ id: string; content: string; filename: string | null }> {
    return this.api.get<{ id: string; content: string; filename: string | null }>(`/trove/${id}`)
  }

  /** Edit a Diwa-born note. Imported notes 403 — the vault is the source of truth. */
  update(id: string, content: string): Promise<UpdateResult> {
    return this.api.patch<UpdateResult>(`/trove/${id}`, { content })
  }

  /** Stage 1 of a folder import: paths in, gated shortlist out. No contents cross yet. */
  bulkPropose(paths: { path: string; size: number }[]): Promise<BulkProposal> {
    return this.api.post<BulkProposal>('/trove/bulk/propose', { paths })
  }
}

export interface BulkProposal {
  selected: string[]
  heuristic_count: number
  ignored: number
  capped: boolean
  total: number
}
